<template>
  <span class="all-category">全部分类：</span>
  <ul class="app-header-nav" v-for="fitems in menulist" :key="fitems.chID">
    <li>
      <RouterLink
        :class="{ active: parseInt($route.query.firstCate) == fitems.chID }"
        :to="`/news/newslist?firstCate=${fitems.chID}`"
        >{{ fitems.chName }}
      </RouterLink>
    </li>
  </ul>
  <hr v-show="$route.query.firstCate" />
  <div style="margin-left: 80px" v-if="subList">
    <ul class="app-header-nav" v-for="sitems in subList" :key="sitems.coID">
      <li v-show="$route.query.firstCate">
        <RouterLink
          :class="{ active: parseInt($route.query.secondCate) == sitems.coID }"
          :to="`/news/newslist?firstCate=${$route.query.firstCate}&secondCate=${sitems.coID}`"
          >{{ sitems.coName }}
        </RouterLink>
      </li>
    </ul>
  </div>

  <div style="margin-left: 75px">
    <hr v-show="$route.query.secondCate" />
    <ul class="titems" v-for="items in thrList" :key="items.clID">
      <li>
        <RouterLink
          :class="{ active: parseInt($route.query.thirdCate) == items.clID }"
          :to="`/news/newslist?firstCate=${$route.query.firstCate}&secondCate=${$route.query.secondCate}&thirdCate=${items.clID}`"
          >{{ items.clName }}
        </RouterLink>
      </li>
    </ul>
    <hr v-show="$route.query.thirdCate" />
  </div>
</template>

<script>
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { computed, watch, ref, reactive } from "vue";

export default {
  // eslint-disable-next-line vue/no-setup-props-destructure
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    //const emit = defineEmits(["firstcate"]);
    //const emit = defineEmits(["firstcate"]);
    //const emits = defineEmits(["firstCate","secondCate","thirdCate"])
    const menulist = computed(() => {
      let list = store.state.category.list.filter((items) => items.pid === 0);
      return list;
    });

    const CurrentList = ref("");
    const subList = computed(() => {
      return store.state.category.list.filter(
        (item) => parseInt(item.caID) === parseInt(route.query.firstCate)
      );
    });
    const thrList = computed(() => {
      return store.state.category.list.filter(
        (item) => item.cbID === parseInt(route.query.secondCate)
      );
    });

    return {
      menulist,
      CurrentList,
      subList,
      thrList,
    };
  },
};
</script>

<style lang="less" scoped>
hr {
  border: 1px solid rgb(252, 255, 252);
}
.all-category {
  font-size: 16px;
  line-height: 45px;
  font-weight: bold;
  height: 45px;
}
.app-header-nav {
  display: inline-block;
  padding-left: 10px;
  li {
    margin-right: 15px;
    text-align: center;
    a {
      font-size: 16px;
      line-height: 45px;
      font-weight: bold;
      height: 45px;
      display: inline-block;
    }
    &:hover {
      a {
        cursor: pointer;
        color: @shColor;
        border-bottom: 1px solid @shColor;
      }
    }
    .active {
      color: @shColor;
      border-bottom: 1px solid @shColor;
    }
  }
}
.titems {
  display: inline-block;
  padding-left: 15px;
  li {
    margin-right: 15px;
    text-align: center;
    a {
      font-size: 14px;
      line-height: 35px;
      font-weight: bold;
      height: 35px;
      display: inline-block;
    }
    &:hover {
      a {
        cursor: pointer;
        color: @shColor;
        border-bottom: 1px solid @shColor;
      }
    }
    .active {
      color: @shColor;
      border-bottom: 1px solid @shColor;
    }
  }
}
</style>
